import { useDispatch } from "react-redux";
import { addToaster, removeToaster } from "../store";

// // // //

enum ToasterVariants {
    primary = "primary",
    success = "success",
    warning = "warning",
    danger = "danger",
}
type ToasterVariant = `${ToasterVariants}`;

interface AddToasterProps {
    message: string;
    variant?: ToasterVariant;
    dismissible?: boolean;
    timeout?: number;
}

type AddToasterFunction = (addToasterProps: AddToasterProps) => void;

interface RemoveToasterProps {
    id: string;
}

type RemoveToasterFunction = (removeToasterProps: RemoveToasterProps) => void;

export function useToaster(): {
    addToaster: AddToasterFunction;
    removeToaster: RemoveToasterFunction;
} {
    const dispatch = useDispatch();

    // Expose state via props.children
    return {
        addToaster: (addToasterProps: AddToasterProps) => {
            const {
                message,
                variant = "primary",
                dismissible = true,
                timeout = 5000,
            } = addToasterProps;
            dispatch(
                addToaster({
                    message,
                    variant,
                    dismissible,
                    duration: timeout,
                }),
            );
        },
        removeToaster: (removeToasterProps: RemoveToasterProps) => {
            dispatch(
                removeToaster({
                    ...removeToasterProps,
                }),
            );
        },
    };
}
